import React, { useRef, useState, useEffect } from "react";
import Chatroom from "../chatroom";
import Chatfooter from "../chatfooter";
import ChatBotHeader from "./Header";
import {
  serverTimestamp,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";
import "./chatbot.css";
import { db } from "../../config/firebase";

function ChatBot(props) {
  const [newMessages, setNewMessage] = useState([]);
  const [startNewChat, setStartNewChat] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const chatRoomRef = useRef(null);
  const [showExtraContent, setShowExtraContent] = useState(true);
  
  // Ref to store the refresh handler from Chatroom
  const refreshHandlerRef = useRef(null);

  // Function to toggle the extra content visibility
  const toggleExtraContent = () => {
    setShowExtraContent(prev => !prev);
  };

  // Function to handle refresh click from header
  const handleRefreshFromHeader = () => {
    // Call the refresh handler from Chatroom if it exists
    if (refreshHandlerRef.current) {
      refreshHandlerRef.current();
    }
  };

  // Function to receive the refresh handler from Chatroom
  const setRefreshHandler = (handler) => {
    refreshHandlerRef.current = handler;
  };

  const setCookie = (name, value, days = 30) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  function getCurrentISTDate() {
    const date = new Date();

    // Convert the current date to IST by adding the IST offset
    const utcOffset = date.getTimezoneOffset(); // Offset in minutes
    const istOffset = 330; // IST offset in minutes (UTC+5:30)
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);

    // Get the year, month, and day
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const day = String(istDate.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  // Export messages function
  const exportMessages = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      
      if (!storedData) {
        alert("No messages found to export.");
        return;
      }

      const parsedData = JSON.parse(storedData);
      const docid = parsedData.key;
      
      // Fetch messages from Firestore
      const docRef = doc(db, "Messages", docid);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        const messages = data.Messages || [];
        
        // Filter only user messages (assuming user messages don't have 'server' field or have 'user' field)
        const userMessages = messages.filter(msg => 
          msg.user && !msg.server || 
          (msg.hasOwnProperty('user') && !msg.hasOwnProperty('server'))
        );
        
        if (userMessages.length === 0) {
          alert("No user messages found to export.");
          return;
        }
        
        // Create export data - only content
        const exportData = {
          exportDate: new Date().toISOString(),
          totalUserMessages: userMessages.length,
          userMessages: userMessages.map((msg, index) => ({
            messageNumber: index + 1,
            content: msg.user || msg.message || msg.text
          }))
        };
        
        // Create and download file
        const dataStr = JSON.stringify(exportData, null, 2);
        const dataBlob = new Blob([dataStr], { type: 'application/json' });
        
        const link = document.createElement('a');
        link.href = URL.createObjectURL(dataBlob);
        link.download = `user_messages_${getCurrentISTDate()}.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up the URL object
        URL.revokeObjectURL(link.href);
        
        console.log("Messages exported successfully!");
      } else {
        alert("No conversation data found.");
      }
    } catch (error) {
      console.error("Error exporting messages:", error);
      alert("Failed to export messages. Please try again.");
    }
  };

  // Save action to Firestore (similar to ChatFooter handlechange)
  const saveActionToFirestore = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const channel = urlParams.get("channel") || "Web";
      const shopId = currentDomain || "null";
      
      const uidvar = currentDomain + "uid";
      let uid = getCookie(uidvar) || "";

      const currentTime = new Date();
      const seconds = currentTime.getSeconds();
      const month = String(currentTime.getMonth() + 1).padStart(2, "0");
      const day = String(currentTime.getDate()).padStart(2, "0");
      const year = currentTime.getFullYear();
      const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
      const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
      const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
      
      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      let docid = "";

      if (!storedData) {
        const initialData = { key: uid + Date.now().toString() };
        setCookie(data_var, JSON.stringify(initialData));
        docid = initialData.key;
        const docRef = doc(db, "Messages", docid);
        const docSnap = await getDoc(docRef);
        let assigned_to = "bot@krunk.ai";

        if (!docSnap.exists()) {
          await setDoc(docRef, {
            Chat_Status: "Open",
            Fetch_Firestore: true,
            Messages: [{ server: "Hi! How can I help you today?", server_timestamp: date_string }],
            server: false,
            user_id: uid,
            shop_id: shopId,
            User_Channel: "Web",
            timestamp: Date.now(),
            ticket_id: docid,
            assigned_to: "bot@krunk.ai",
            doc_id: docid,
            User_Timestamp: getCurrentISTDate(),
            created_at: serverTimestamp(),
            last_updated: serverTimestamp(),
          }, { merge: true });
        }
      } else {
        const parsedData = JSON.parse(storedData);
        docid = parsedData.key;
      }
    } catch (error) {
      console.error("Error saving action to Firestore:", error);
    }
  };

  // Call saveActionToFirestore when component mounts
  useEffect(() => {
    saveActionToFirestore();
  }, []); // Empty dependency array means this runs once when component mounts

  return (
    <div className="krunk-h-full krunk-flex krunk-items-center krunk-justify-center">
      {showExtraContent && (
        <button
          onClick={toggleExtraContent}
          className="krunk-fixed krunk-right-4 krunk-top-1/2 krunk-transform krunk--translate-y-1/2 krunk-w-12 krunk-h-12 krunk-text-white krunk-rounded-full krunk-shadow-lg krunk-flex krunk-items-center krunk-justify-center krunk-transition-all krunk-duration-300 krunk-z-50"
          aria-label="Toggle extra content"
        >
          <img 
            src={props.imageurl} 
            alt="Toggle button" 
            className="krunk-w-full krunk-h-full krunk-object-cover krunk-rounded-full"
          />
        </button>
      )}

      {!showExtraContent && (
        <div   
          style={{ boxShadow: "3px 3px 5px 0 rgba(0, 0, 0, 0.3)" }}
          className="krunk-border krunk-border-gray-100 krunk-bg-white krunk-rounded-xl krunk-bg-headercolor krunk-h-full krunk-w-full sm:krunk-w-[420px] krunk-flex krunk-flex-col krunk-max-h-[650px]"
        >
          <div className="krunk-rounded-xl krunk-h-full krunk-font-[Poppins] krunk-text-[#333333] krunk-flex krunk-flex-col">
            <ChatBotHeader 
              title={props.title} 
              imageurl={props.imageurl} 
              showExtraContent={showExtraContent}
              toggleExtraContent={toggleExtraContent}
              onRefresh={handleRefreshFromHeader} // Pass the refresh handler to header
            />
            <main
              ref={chatRoomRef}
              className="krunk-px-4 krunk-flex-1 krunk-border-2 krunk-border-gray-50 krunk-overflow-y-auto krunk-scrollbar-none"
            >
              <div className="krunk-flex krunk-flex-col krunk-h-full">
                <Chatroom 
                  sharedData={newMessages} 
                  userId={props.userId} 
                  isLoading={isLoading}  
                  setIsLoading={setIsLoading}
                  actionButtons={props.actionButtons}
                  subMenu={props.subMenu}
                  onRefreshHandler={setRefreshHandler} // Pass the setter to Chatroom
                />
              </div>
            </main>
     
            <footer className="krunk-text-primary krunk-rounded-b-3xl">
              <Chatfooter
                messageupdate={setNewMessage}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                setStartNewChat={setStartNewChat}
                startNewChat={startNewChat}
              />
            </footer>
          </div>
        </div>
      )}
      
      {/* Export Button - Only visible on laptops/desktops */}
      {!showExtraContent && (
        <button
          onClick={exportMessages}
          className="krunk-fixed krunk-bottom-4 krunk-left-4 krunk-bg-blue-600 hover:krunk-bg-blue-700 krunk-text-white krunk-px-4 krunk-py-2 krunk-rounded-lg krunk-shadow-lg krunk-flex krunk-items-center krunk-gap-2 krunk-transition-all krunk-duration-300 krunk-z-50 krunk-hidden lg:krunk-flex"
          aria-label="Export user messages"
          title="Export user messages to file"
        >
          <svg 
            className="krunk-w-4 krunk-h-4" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
            />
          </svg>
          <span className="krunk-text-sm krunk-font-medium">Export</span>
        </button>
      )}
    </div>
  );
}

export default ChatBot;